import { IMediaStreamDefaults } from 'components/UserMedia/IUserMedia';
import { BROWSER_CAPABILITIES } from 'utils/browserCapabilities';

export const getVideoTrackConstraints: (
  constraints: MediaTrackConstraints | boolean,
  defaults: IMediaStreamDefaults,
) => MediaTrackConstraints | boolean = (constraints, defaults) => {
  if (!constraints) {
    return false;
  }

  if (typeof constraints === 'boolean') {
    return true;
  }

  const aspectRatio: number =
    constraints.width && constraints.height
      ? Number(constraints.width) / Number(constraints.height)
      : defaults.baseAspectRatio;

  const config: MediaTrackConstraints = {};

  if (constraints.frameRate) {
    config.frameRate = { ideal: constraints.frameRate, min: 15 } as ConstrainDouble;
  }

  if (constraints.facingMode) {
    const supportedConstraints: MediaTrackSupportedConstraints =
      navigator.mediaDevices.getSupportedConstraints();

    if (supportedConstraints.facingMode) {
      config.facingMode = { exact: constraints.facingMode } as ConstrainDOMString;
    }
  }

  if (constraints.width) {
    config.width = { ideal: constraints.width } as ConstrainULong;
  }

  if (constraints.height) {
    config.height = { ideal: constraints.height } as ConstrainULong;
  }

  if (constraints.width && constraints.height && aspectRatio) {
    config.aspectRatio = aspectRatio;
  }

  if (constraints.deviceId) {
    config.deviceId = BROWSER_CAPABILITIES.safari
      ? constraints.deviceId
      : ({ exact: constraints.deviceId } as ConstrainDOMString);
  }

  if (constraints.width && constraints.height && !config.facingMode) {
    config.advanced = [
      {
        width: {
          min: (constraints.width as number) - defaults.sizeThreshold,
          max: (constraints.width as number) + defaults.sizeThreshold,
        },
        height: {
          min: (constraints.height as number) - defaults.sizeThreshold,
          max: (constraints.height as number) + defaults.sizeThreshold,
        },
      },
      { aspectRatio },
    ];
  }

  if (Object.keys(config).length === 0) {
    return false;
  }

  return config;
};
